import { Grid } from '@mui/material'
import * as controllers from 'controllers'
import { VehicleDamageDetailsDto, VehicleDamageDto } from 'dtos'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import DamageDetailsCard from '../DamageDetailsCard'
import DamageNotesListCard from '../DamageNotesListCard'
import DamagePhotosListCard from '../DamagePhotosListCard'
import DamageDetailsHeroCard from './DamageDetailsHeroCard'

export default function DamageDetailsIndex() {
  const { vehicleGuid, damageGuid } = useParams()
  const [damageDetails, setDamageDetails] = useState<VehicleDamageDetailsDto>(new VehicleDamageDto())

  useEffect(() => {
    if (!vehicleGuid || !damageGuid) {
      return
    }

    controllers.getDamageDetails(vehicleGuid, damageGuid).then(response => {
      setDamageDetails(response.value)
    })
  }, [vehicleGuid, damageGuid])

  return (
    <Grid container spacing={2} alignItems='flex-start'>
      <Grid item xs={12}>
        <DamageDetailsHeroCard damage={damageDetails} />
      </Grid>

      <Grid item xs={4}>
        <DamageDetailsCard />
      </Grid>

      <Grid item xs={4}>
        <DamagePhotosListCard damage={damageDetails} />
      </Grid>

      <Grid item xs={4}>
        <DamageNotesListCard />
      </Grid>
    </Grid>
  )
}
